import {HexMath} from "../../HexMath";
import {ConstructionAccessibility} from "../../ConstructionAccessibility";
import {selectRound} from "../../../redux/reducers/sharedStateReducer/selectors";

export const calculateAvailableConstructionCellsForCommonBuilding = (state, playerOverride = null, options = {}) => {
  const hexMath = new HexMath(30, 'flat');
  const constructionAccessibility = new ConstructionAccessibility(hexMath);
  const currentRound = selectRound(state);

  if (currentRound === 1) {
    return constructionAccessibility.findAccessibleConstructionCellsForFirstRound(state, playerOverride);
  }

  return constructionAccessibility.findAccessibleCellsForConstruction(state, playerOverride, options);
};

/**
 * Проверка одной ячейки — тот же ответ, что
 * calculateAvailableConstructionCellsForCommonBuilding(...).includes(hexKey),
 * но без поиска пути от каждой ячейки поля: там, где нужна одна ячейка
 * (перепроверка плана строительства). Ветки — те же, что в полном расчете выше
 * @returns {(hexKey: string) => boolean}
 */
export const createCommonBuildingCellAvailabilityCheck = (state, playerOverride = null, options = {}) => {
  const constructionAccessibility = new ConstructionAccessibility(new HexMath(30, 'flat'));

  // Первый раунд — только смежность со своими кварталами, поиска пути нет
  if (selectRound(state) === 1) {
    const cells = new Set(constructionAccessibility.findAccessibleConstructionCellsForFirstRound(state, playerOverride));
    return (hexKey) => cells.has(hexKey);
  }

  return constructionAccessibility.createAccessibleCellForConstructionPredicate(state, playerOverride, options);
};
